/**
 *
 * @description 视频懒加载
 * - <video data-src={src} data-poster={poster} autoPlay playsInline loop muted/>
 *
 */

function ImageLazyLoad(threshold = 300, dom) {
  const lazyLoadImages = [].slice.call((dom || document).querySelectorAll('img[data-src]'));
  if ('IntersectionObserver' in window) {
    let imageObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (_image) {
          if (_image.isIntersecting) {
            let image = _image.target;
            image.src = image.getAttribute('data-src');
            imageObserver.unobserve(image);
          }
        });
      },
      {
        root: document.getElementById('_next'),
        rootMargin: `${threshold}px 0px`,
      }
    );

    lazyLoadImages.forEach(function (image) {
      imageObserver.observe(image);
    });
  } else {
    let lazyLoadThrottleTimeout;

    const lazyLoad = () => {
      if (lazyLoadThrottleTimeout) {
        clearTimeout(lazyLoadThrottleTimeout);
      }

      lazyLoadThrottleTimeout = setTimeout(function () {
        let scrollTop = window.pageYOffset;
        lazyLoadImages.forEach(function (image) {
          if (image.offsetTop < window.innerHeight + scrollTop) {
            image.src = image.getAttribute('data-src');
          }
        });
        if (lazyLoadImages.length === 0) {
          document.removeEventListener('scroll', lazyLoad);
        }
      }, 20);
    };

    document.addEventListener('scroll', lazyLoad);
  }
}

/**
 *
 * @param {HTMLImageElement} imgEle 视频元素
 * @param {string} eleTag 自定义属性标识，默认data-src|poster，添加标识后为data-xxx-src|poster
 * @param {number} threshold
 * @returns {IntersectionObserver} observer
 */
export function ImgLazyLoadSingle(imgEle, eleTag = '', threshold = 300) {
  const imgLoaded = (ele) => ele.getAttribute('src');
  let imageObserver = null;
  const imgSrc = eleTag ? `data-${eleTag}-src` : 'data-src';
  if (imgLoaded(imgEle)) return imageObserver;
  if ('IntersectionObserver' in window) {
    imageObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((_image) => {
          if (_image.isIntersecting) {
            let image = _image.target;
            image.src = image.getAttribute(imgSrc);
            imageObserver.unobserve(image);
          }
        });
      },
      {
        root: document.getElementById('_next'),
        rootMargin: `${threshold}px 0px`,
      }
    );

    imageObserver.observe(imgEle);
  } else {
    let lazyLoadThrottleTimeout;

    const lazyLoad = () => {
      if (lazyLoadThrottleTimeout) {
        clearTimeout(lazyLoadThrottleTimeout);
      }

      lazyLoadThrottleTimeout = setTimeout(() => {
        let scrollTop = window.pageYOffset;
        if (imgEle.offsetTop < window.innerHeight + scrollTop) {
          imgEle.src = imgEle.getAttribute(imgSrc);
        }
        document.removeEventListener('scroll', lazyLoad);
      }, 20);
    };

    document.addEventListener('scroll', lazyLoad);
  }
  return imageObserver;
}

export default ImageLazyLoad;
